import {Inject, Injectable} from '@angular/core';

import { HttpClient, HttpHeaders, HttpBackend } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DadataConfig} from '../components/dadata/dadata-config';

import {DadataResponse} from '../interfaces/DadataResponse';
import {Environment} from '../interfaces/Environment';

@Injectable({
  providedIn: 'root'
})
export class DadataService {

  private http: HttpClient;


  constructor(
    @Inject('environment') private readonly environment: Environment,
    readonly httpBackend: HttpBackend
  )
  {
    this.http = new HttpClient(httpBackend);
  }

  getSuggestion(query: string, config: DadataConfig): Observable<DadataResponse> {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Token ' + this.environment.dadataToken,
        'ngsw-bypass': 1
      })
    };
    const body = Object.assign(
      {},
      {query},
      {count: config?.limit},
      {locations: config?.locations},
      {restrict_value: true},
      {from_bound: config?.bounds?.fromBound},
      {to_bound: config?.bounds?.toBound}
    );
    return this.http.post<DadataResponse>('https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/' + config.type, body, options);
  }

}
